import { handleActions, combineActions } from 'redux-actions';
import { reduxKey } from './constants';
import { NetworkBarStoreSlice } from './types';
import {
  initializeNetworkBar,
  markChannelAsRead,
  updateNetworkBarSection,
  setNetworkBarSection,
} from './actions';
import { generateMainNavigation, getMainNavigationItems } from './helpers';

const handler = handleActions<NetworkBarStoreSlice, any>(
  {
    [initializeNetworkBar.toString()]: (
      state,
      {
        payload: { mainNavNewContent },
      }: ReturnType<typeof initializeNetworkBar>
    ) => ({
      ...state,
      mainNavigation: generateMainNavigation(mainNavNewContent),
      isInitialized: true,
    }),
    [markChannelAsRead.toString()]: (
      state,
      { payload: { channel } }: ReturnType<typeof markChannelAsRead>
    ) => {
      // groups are handled by saga, this takes care of the main nav
      const navItem = state.mainNavigation.find(n => n.key === channel);
      if (navItem?.hasNewContent) {
        return {
          ...state,
          mainNavigation: state.mainNavigation.map(n =>
            n === navItem ? { ...n, hasNewContent: false } : n
          ),
        };
      }

      return state;
    },
    [combineActions(updateNetworkBarSection, setNetworkBarSection).toString()]:
      (
        state,
        {
          payload: { section, isFoldedNow },
        }: ReturnType<typeof updateNetworkBarSection>
      ) =>
        state.sections[section].isFolded === isFoldedNow
          ? state
          : {
              ...state,
              sections: {
                ...state.sections,
                [section]: { isFolded: isFoldedNow },
              },
            },
  },
  {
    isInitialized: false,
    mainNavigation: getMainNavigationItems(),
    sections: {
      watched_groups: { isFolded: false },
      recommended_groups: { isFolded: false },
    },
  }
);

export default {
  [reduxKey as string]: handler,
};
